import {DeepLinkActionBase} from '../deep-link-action-base';

export class FreePlayDeepLinkAction extends DeepLinkActionBase {
  async execute(): Promise<void> {

    this.services.logger.info("FreePlay Deeplink arrived");

    if(!this.services.user.isAuthorized){
      await this.services.user.openLogin(this.descriptor.marketingParams);
    }

    const freePlayArriveSubscribe = this.services.sdk.events.onFreeplayVouchersUpdated((data: unknown[]) => {
      const numberOfFreeplays = data ? data.length : 0;

      if(numberOfFreeplays > 0){
        this.services.logger.info("FreePlay Deeplink drawer open");
        this.services.userMenu.openRewards();
        freePlayArriveSubscribe && freePlayArriveSubscribe.off();
      }
    });
  }
}
